'use client'
const MAX_DISPLAY_LENGTH = 20;
/**
 * This is the value that will be displayed when the value is not available.
 */
const UNAVAILABLE_VALUE = '--';

export { MAX_DISPLAY_LENGTH, UNAVAILABLE_VALUE };
